export default __webpack_public_path__ + "static/media/homepage_module_adjusted-participation.8532b73f.png";